import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type PoolCardContainerProps = {
  poolId: number;
  children: ReactNode;
  className?: string;
  hoverEffect?: 'lift' | 'shadow' | 'none';
  borderColor?: string;
  type?: 'link' | 'button';
  onClick?: (() => void) | undefined;
} & (
  | {
      type?: 'link';
      onClick?: undefined;
    }
  | {
      type: 'button';
      onClick: () => void;
    }
);

export function PoolCardContainer({
  poolId,
  children,
  className = '',
  hoverEffect = 'shadow',
  borderColor,
  type = 'link',
  onClick,
}: PoolCardContainerProps) {
  const hoverClasses = {
    lift: 'hover:-translate-y-0.5 hover:shadow-[0px_8px_20px_rgba(17,61,123,0.15)]',
    shadow: 'hover:shadow-lg',
    none: '',
  };

  const borderClass = borderColor ? `border-[${borderColor}]` : 'border-gray-200';
  const classes = clsx(
    'block bg-white rounded-3xl border cursor-pointer transition-all duration-200',
    borderClass,
    hoverClasses[hoverEffect],
    className
  );

  if (type === 'link') {
    return (
      <Link to={`/pools/${poolId}`} className={classes}>
        {children}
      </Link>
    );
  }

  return (
    <div className={classes} onClick={onClick}>
      {children}
    </div>
  );
}
